<template>
<!-- 品牌店铺 -->
<section>
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form class="findform">
        <el-form-item label="店铺名称：" style="display:flex;width:33%">
          <el-input v-model="filters.channelName" placeholder="请输入店铺名称 (20字以内)" maxlength="20" style="width: 90%"/>
        </el-form-item>
        <el-form-item label="所属企业：" style="display:flex;width:33%;">
          <el-input v-model="filters.partnerGender" placeholder="请输入所属企业" maxlength="20" style="width: 90%"/>
        </el-form-item>
        <el-form-item label="联系电话：" style="display:flex;width:33%">
          <el-input v-model="filters.partnerPhone" placeholder="请输入联系电话" maxlength="11" style="width: 90%;"/>
        </el-form-item>
      </el-form>
      <el-form class="findform">
        <el-form-item label="地　　区：" style="display:flex;width:33%;">
          <el-input v-model="filters.partnerRegion" placeholder="请输入城市" maxlength="20" style="width: 90%;"/>
        </el-form-item>
        <el-form-item label="店铺类型：" style="display:flex;width:33%;">
          <el-select v-model="filters.shopType" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in shopTypeArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">品牌店铺列表</p>
      <el-button type="danger" @click="addPartner()">添加店铺</el-button>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" stripe border>
        <el-table-column label="店铺名称" align="center">
          <template scope="scope">
            <span :title="scope.row.name">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺类型" align="center">
          <template scope="scope">{{scope.row.bbTypeName}}</template>
        </el-table-column>
        <el-table-column label="负责人" align="center">
          <template scope="scope">{{scope.row.contacts}}</template>
        </el-table-column>
        <el-table-column label="联系电话" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="所属企业" align="center">
          <template scope="scope">{{scope.row.enterpriseName}}</template>
        </el-table-column>
        <el-table-column label="入驻时间" align="center">
          <template scope="scope">{{scope.row.entryTime}}</template>
        </el-table-column>
        <el-table-column label="地区" align="center">
          <template scope="scope">{{scope.row.region}}</template>
        </el-table-column>
        <!-- <el-table-column label="让利比例" align="center">
          <template scope="scope">{{scope.row.rate}}</template>
        </el-table-column> -->
        <el-table-column label="导购" align="center">
          <template scope="scope">{{scope.row.guideCount}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="cliSeePartner(scope.row)" class="handle"> <i class="el-icon-edit-outline"/> 编辑 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 添加店铺-弹框 -->
  <el-dialog title="添加店铺" :visible.sync="isToExamine" :center="true" width="40%">
    <el-form>
      <el-form class="formItem">
        <el-form-item label="店铺名称 :" style="width:42%;" label-width="88px">
          <el-input v-model="shopName" placeholder="请输入店铺名称 (20字以内)" maxlength="20"/>
        </el-form-item>
        <el-form-item label="手机号 :" style="width:42%;" label-width="88px">
          <el-input v-model="shopPhone" placeholder="请输入手机号" maxlength="11"
          onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')"/>
        </el-form-item>
      </el-form>
      <el-form class="formItem">
        <el-form-item label="管理者名字 :" style="width:42%;" label-width="88px">
          <el-input v-model="contactsName" placeholder="请输入管理者名字" maxlength="20"/>
        </el-form-item>
        <el-form-item label="入驻城市 :" style="width:42%;" label-width="88px">
          <el-cascader v-model="chengshi" placeholder="请选择城市" style="background:#fff;width:100%"
          :options="optionDetails" filterable clearable @change="addHandleChangeDetails"/>
        </el-form-item>
      </el-form>
      <el-form class="formItem">
        <el-form-item label="详细地址 :" style="width:42%;" label-width="88px">
          <el-input v-model="detailedAddress" @input="adcodeclick" id="pickerInput"
            placeholder="请输入详细地址" maxlength="20"/>
        </el-form-item>
        <el-form-item label="门牌号 :" style="width:42%;" label-width="88px">
          <el-input v-model="houseNumber" placeholder="请输入门牌号" maxlength="20"/>
        </el-form-item>
      </el-form>
      <el-form-item label="店铺视频 :" style="width:86%;" label-width="88px">
        <div style="display:flex;">
          <el-input v-model="videoUrl" :disabled="true" placeholder="请上传店铺视频" style="width:55%;"/>
          <div class="hiddenInput"> 选择文件
            <input type="file" id="file" accept="video/*" @change="handleFile" ref="pathClear"/>
          </div>
          <span class="elUploadTip" v-if='isEdit'>{{isProcessing}}</span>
        </div>
        <div style="color:#888;line-height: 10px;"> 视频格式仅支持: mp4. 视频大小不能超过 50MB ! <br>
          <el-button type="danger" v-show="videoUrl" @click="newSeevideo()">预 览</el-button>
        </div>
      </el-form-item>
      <el-form-item label="店铺图片 :" style="width:86%;" label-width="88px">
        <div class="upload " style="display:inline-block">
          <el-upload class="avatar-uploader" style action :show-file-list="false" :before-upload="beforeAvatarUpload3">
            <img style="width:172px;height:82px" v-if="imageUrl" :src="imageUrl"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div style="color:#888;line-height: 10px;">建议尺寸：1200*675，支持的图片格式：jpg、png !</div>
      </el-form-item>
      
    </el-form>
    <!-- 弹框按钮 -->
    <div style="text-align:center">
      <button type="button" @click="editSubmit()" class="el-button search_btn normal_btn">添加</button>
      <button type="button" @click="isToExamine = false" class="el-button cancle normal_btn">关闭</button>
    </div>
  </el-dialog>

  <el-dialog :visible.sync="videoVisible"  width="30%" @close="closeDialog">
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions" />
  </el-dialog>

</section>
</template>
<script>
import { uploadOSS } from '../../utils/oss';
import { getOssFile, uploadVedio } from '../../api/newOss';
import { getProvinceAndCityAndZoneByDataType } from "../../api/api";
import { getpaginationList, postDetails } from "../../api/attractInvestment";
// import AMap from "AMap";
export default {
  name: 'brandStore',
  data() {
    return {
      show3: true, // 查询区域默认展开
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      filters: {
        channelName: "", // 姓名
        partnerGender: "", // 所属企业
        partnerPhone: "", // 联系电话
        partnerRegion: "", // 地区
        shopType: 0, // 店铺类型
      },
      shopTypeArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "品牌建材"
        },
        {
          Id: 2,
          Name: "装修公司"
        }
      ],

      isToExamine: false, // 弹框
      shopName: "", // 店铺名称
      shopPhone: "", // 手机号
      contactsName: "", // 管理者名字
      chengshi: "", // 城市
      detailedAddress: '', // 详细地址
      houseNumber: '', // 门牌号信息
      // 入驻城市
      optionDetails: [],
      provinceDetailsId: 0,
      cityDetailsId: 0,
      zoneDetailsId: 0,

      videoUrl: "", // 全连接
      newVideoUrl: "", // 切割之后链接
      isEdit: false,
      isProcessing: "",
      imageUrl: "",
      imageUrlQiege: "",

      marker: "",
      map: "",
      infoarr: "",
      Lat: "",
      Lng: "",
      placeSearch: null,
      adcode: "100000",
      districtName: "",

      //视频播放
      VedioFile: null,
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          // type: 'application/x-mpegURL', // 这里的种类支持很多种：基本视频格式、直播、流媒体等
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      videoVisible: false,
      isUploadSuc: false //判断视频是否上传成功
    }
  },
  mounted() {
    if (window.AMap) {
      const AMap = new window.AMap.Map('container', {
        zoom: 10,
        center: [116.39, 39.9]
      });
    } else {
      console.error('AMap is not loaded');
    }
  },
  methods: {
    // 查询品牌店铺列表
    getInit() {
      let addParams = {
        UserId: localStorage.Id, // 用户id
        shopName: this.filters.channelName, // 店铺名称
        enterpriseName: this.filters.partnerGender, // 所属企业
        phone: this.filters.partnerPhone, // 联系电话
        zoneName: this.filters.partnerRegion, // 地区
        BbType: this.filters.shopType, // 店铺类型
        pageIndex: this.pageIndex,// 当前页码
        pageSize: this.pageSize // 每页显示条数
      };
      // var header = {headers:{"Content-Type":'application/json;'}}
      getpaginationList(addParams).then(data => {
        this.dataList = data.resultObj.resultObj;
        this.totalRowsCount = data.resultObj.rowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 添加店铺
    addPartner() {
      // this.adcodeclick();
      // this.handlesearch();
      // this.getlookupProvinceAndCity(); // 查询省市区级联数据
      // this.isToExamine = true; // 详情弹框展示
      // this.shopName = ""; // 店铺名称
      // this.shopPhone = "", // 手机号
      // this.contactsName = ""; // 管理者名字
      // this.chengshi = ""; // 入驻城市
      // this.detailedAddress = ""; // 详细地址
      // this.houseNumber = ""; // 门牌号信息
      // this.videoUrl = ""; // 清空店铺视频
      // this.isProcessing = "";
      // this.imageUrl = ""; //  清空店铺图片
      this.$router.push({
        path: "/seeFindshop",
        query: {
          type: 0
        }
      });
    },
    
    // 编辑
    cliSeePartner(row) {
      localStorage.businessBbId = row.id;
      this.$router.push({
        path: "/seeFindshop",
        query: {
          type: 1,
          storeType: row.bbType // 店铺类型
        }
      });
    },

    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;

    },
    closeDialog() {
      // this.$refs.videoPlayer.player.play() // 播放
      // this.$refs.videoPlayer.player.pause() // 暂停
      this.$refs.videoPlayer.player.pause();
    },
    // 上传店铺视频
    async handleFile(event) {
      if (event.target.files[0].size > 50*1024 * 1024) {
        this.$swal({
          type:"warning",
          text:"请上传小于50MB的文件"
        })
        return false;
      }

      if (!(event.target.value.indexOf("mp4") != -1)) {
        this.$swal({
          type:"warning",
          text:"请上传mp4格式的文件"
        })
        return false;
      }

      let url = getFileURL(event.target.files[0]); //把当前的 files[0] 传进去
      if(url) {

        this.VedioFile = event.target.files[0];
        this.videoUrl = url;
        this.newVideoUrl = url;
        this.$refs.pathClear.value ='';
      }

      function getFileURL(file) {
        let getUrl = null;
        if(window.createObjectURL != undefined) { // basic
          getUrl = window.createObjectURL(file);
        } else if(window.URL != undefined) { // mozilla(firefox)
          getUrl = window.URL.createObjectURL(file);
        } else if(window.webkitURL != undefined) { // webkit or chrome
          getUrl = window.webkitURL.createObjectURL(file);
        }
        return getUrl;
      }

    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoUrl.indexOf("blob:") != -1){
        window.open(this.videoUrl);
      }else{
        this.palySeevideo(this.videoUrl);
      }
    },
    // 店铺图片
    beforeAvatarUpload3(file) {
      const isJPG = file.type
      if (isJPG !='image/jpeg'&&isJPG !='image/png'){
        this.$swal({
          type:"warning",
          text:"上传图片格式应为jpg/png"
        })
        return false
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {type: 3};
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
              
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.imageUrl = newOssPic;
          that.imageUrlQiege = newOssPic.replace(localStorage.BaseOssUrl,'')
          
        };
      },() => {
          this.$swal({
            type:"warning",
            text:"上传图片宽高应为1200*675"
          })
          return Promise.reject();
        }
      );
      return isSize;
      // };
    },
    // 添加
    editSubmit() {

      if(this.shopName == ""){
        this.$swal({
          type:'warning',
          text: '请输入店铺名称 !',
        })
        return false;
      }
      if(this.shopPhone == ""){
        this.$swal({
          type:'warning',
          text: '请输入手机号 !',
        })
        return false;
      }
      if(this.contactsName == ""){
        this.$swal({
          type:'warning',
          text: '请输入管理者名字 !',
        })
        return false;
      }
      if(this.chengshi == ""){
        this.$swal({
          type:'warning',
          text: '请选择入驻城市 !',
        })
        return false;
      }
      if(this.detailedAddress == ""){
        this.$swal({
          type:'warning',
          text: '请输入详细地址 !',
        })
        return false;
      }
      if(this.houseNumber == ""){
        this.$swal({
          type:'warning',
          text: '请输入门牌号信息 !',
        })
        return false;
      }
      if(this.videoUrl == ""){
        this.$swal({
          type:'warning',
          text: '请上传店铺视频 !',
        })
        return false;
      }
      if(this.imageUrl == ""){
        this.$swal({
          type:'warning',
          text: '请上传封面图片 !',
        })
        return false;
      }

      if(this.isUploadSuc){
        this.addData(loading);
        return;
      }


      const loading = this.$loading({
        lock: true,
        text: '保存中. . .',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.76)'
        //loading.close();
      });


      let obj2 = new FormData();
      obj2.append('file',this.VedioFile);
      //上传视频获取路径
      uploadVedio(obj2).then(data=>{
        if(data.resultCode == 1){
          this.videoUrl = data.resultObj.r_m3u8;
          this.newVideoUrl = data.resultObj.r_m3u8;
          this.isEdit=true;
          this.isProcessing = "上传完成";
          this.isUploadSuc = true; //上传完成true  新增编辑后false
          this.addData(loading);
          return;
        }else if(data.resultCode in {0:0,2:2}){
          loading.close();
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
        } else {
          loading.close();
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
        }
      }).catch(error => {
        loading.close();
      });

    },

    addData(loading){
      var loginParams = {
        userId: localStorage.Id, // 用户id
        name: this.shopName, // 店铺名称
        phone: this.shopPhone, // 手机号
        contacts: this.contactsName, // 管理者名字
        address: this.detailedAddress, // 详细地址
        houseNumber: this.houseNumber, // 门牌号信息
        lat: this.Lat, // 经度
        lng: this.lng, // 纬度
        ProvinceId: this.provinceDetailsId, // 省份id
        cityId: this.cityDetailsId, // 城市id
        zoneId: this.zoneDetailsId, // 区域id
        panoramicImg: this.imageUrlQiege, // 封面图片路径
        panoramicUrl: this.newVideoUrl, // 视频路径
      };
      postDetails(loginParams).then(data => {
        loading.close();
        if (data.resultCode == 1) {
          this.$swal({
            text:"添加成功",
            type: "success"
          })
          this.isUploadSuc = false;
          this.isToExamine = false;
          this.getInit();
        }
      })
    },
    // 入驻城市
    addHandleChangeDetails(val) {
      this.provinceDetailsId = val[0];
      this.cityDetailsId = val[1];
      this.zoneDetailsId = val[2];
    },
    // 查找省+市+区
    getlookupProvinceAndCity() {
      var loginParams = {
        isOpen: 1,
        dataLevel: 3
      };
      getProvinceAndCityAndZoneByDataType(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map(item => {
          // 所有省 查当前省下级市
          let provinceData = {value:item.Id,label:item.Name,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 所有市
          item.CityList.map(city => {
            let cityData = {value:city.Id, label:city.Name,children:[]};
            provinceData.children.push(cityData);
            // 区
            city.ZoneList.map(zone => {
              cityData.children.push({value:zone.Id, label:zone.Name});
            })
          })
        });
        that.optionDetails = provinceAndCityAndarea;
      })
    },
    async select(e) {
      this.infoarr = e;
      this.placeSearch.setCity(e.poi.adcode);
      this.placeSearch.search(e.poi.name); //关键字查询查询
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      AMap.event.addListener(this.placeSearch, "markerClick", async e => {
        this.Lat = e.event.lnglat.lat;
        this.lng = e.event.lnglat.lng;
        this.detailedAddress = e.data.name;
      });
      this.lng = e.poi.location.lng;
      this.Lat = e.poi.location.lat;
      this.detailedAddress = e.poi.name;
      console.log(this.Lat, this.lng,'经纬度');
    },
    // 详细地址
    adcodeclick() {
      var that = this;
      var autoOptions = {
        input: "pickerInput",
        city: that.districtName
      };
      var auto = new AMap.Autocomplete(autoOptions);

      var placeSearch = (this.placeSearch = new AMap.PlaceSearch({
        map: that.map,
        city: that.adcode
      }));
      AMap.event.addListener(auto, "select", this.select); //注册监听，当选中某条记录时会触发
      AMap.event.addListener(placeSearch, "click", e => {
        if (this.marker) {
          this.marker.setMap(null);
          this.marker = null;
        }
      });
    },
    //点击搜索
    handlesearch() {
      //清楚marker点
      var that = this;
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      // 输入提示
      var autoOptions = {
        input: "pickerInput",
        city: that.districtName
      };
      var auto = new AMap.Autocomplete(autoOptions);
      var placeSearch = (this.placeSearch = new AMap.PlaceSearch({
        map: that.map,
        city: that.adcode
      }));
      //构造地点查询类
      AMap.event.addListener(auto, "select", this.select); //注册监听，当选中某条记录时会触发
      AMap.event.addListener(placeSearch, "click", e => {
      });
      var marker = new AMap.Marker();
      // let that = this;
      this.placeSearch.search(that.detailedAddress, (status, result) => {
        AMap.event.addListener(this.placeSearch, "markerClick", async e => {
          this.Lat = e.event.lnglat.lat;
          this.lng = e.event.lnglat.lng;
          this.detailedAddress = e.data.name;
        });
      });
    },
    // 重置
    fnReset() {
      this.filters = {
        channelName: "", // 姓名
        partnerGender: "", // 所属企业
        partnerPhone: "", // 联系电话
        partnerRegion: "", // 地区
        shopType: 0, // 店铺类型
      }
      // this.pageIndex = 1;
      // this.getInit();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
  },
  created() {
    this.getInit(); // 查询列表
  }
}
</script>
<style scoped>
/* 添加店铺弹框内容 */
.formItem {
  width: 86%;
  display:flex;
  justify-content: space-between;
}
/* 店铺图片 */
.upload .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.upload .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 170px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eeeeee;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// brandStore.vue?44191b68